import http from './http';

export interface AttorneyInfoRec {
  id: string;
  userId: string;
  firmName?: string;
  attorneyName?: string;
  specialization?: string;
  officeAddress?: string;
  officePhone?: string;
  cellPhone?: string;
  email?: string;
  website?: string;
  barNumber?: string;
  hourlyRate?: number;
  retainerAmount?: number;
  servicesProvided?: string;
  notes?: string;
  isLocked?: boolean;
}

class AttorneyInfoService {
  async getAllAttorneyInfo(targetUserId?: string): Promise<AttorneyInfoRec[]> {
    const params = targetUserId ? `?targetUserId=${targetUserId}` : '';
    const response = await http.get(`/api/attorney-info${params}`);

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch attorney information');
    }

    return response.data.data || [];
  }

  async getAttorneyInfo(targetUserId?: string): Promise<AttorneyInfoRec[]> {
    return this.getAllAttorneyInfo(targetUserId);
  }

  async createAttorneyInfo(data: Partial<AttorneyInfoRec>): Promise<AttorneyInfoRec> {
    const response = await http.post('/api/attorney-info', data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to save attorney information');
    }

    return response.data.data;
  }

  async updateAttorneyInfo(id: string, data: Partial<AttorneyInfoRec>): Promise<AttorneyInfoRec> {
    const response = await http.patch(`/api/attorney-info/${id}`, data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to update attorney information');
    }

    return response.data.data;
  }

  async deleteAttorneyInfo(id: string): Promise<void> {
    const response = await http.delete(`/api/attorney-info/${id}`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete attorney information');
    }
  }

  async lockAttorneyInfo(id: string): Promise<void> {
    const response = await http.post(`/api/attorney-info/${id}/lock`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to lock attorney information');
    }
  }

  async unlockAttorneyInfo(id: string, granteeEmails: string[]): Promise<void> {
    const response = await http.post(`/api/attorney-info/${id}/unlock`, { granteeEmails });
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to unlock attorney information');
    }
  }

  async getAttorneyAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/attorney-info/${id}/access-grants`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch access grants');
    }

    return response.data.data || [];
  }
}

export const attorneyInfoService = new AttorneyInfoService();